import { Box, useTheme, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DrawerContext, DrawerValues } from '../contexts/DrawerContext';
import { useContext } from 'react';
import { UserContext } from '../../../shared/useUser';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isDemoModeEnabled } from '../../../../utils/featureAccess';

export const Header = () => {
  const theme = useTheme();
  const { selectedSystem } = useContext(UserContext);
  const { isMobile, setOpen } = useContext(DrawerContext) as DrawerValues;
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  return (
    <>
      <Box
        sx={{
          paddingTop: '32px',
          paddingBottom: '26px',
          paddingLeft: '8px',
          cursor: 'pointer',
        }}
        onClick={(e) => { navigate('/'); e.stopPropagation(); e.preventDefault(); }}
      >
        <Box display='flex'
          alignItems='center'
          justifyContent='flex-start'
          sx={{
            width: '100%',
            height: '100%',
            position: 'relative',
          }}>
          <img alt='logo'
            src={'/logo-reverse.svg'}
            height='26px' />
          <Typography
            fontSize='16px'
            fontWeight={600}
            color={theme.palette.primary.contrastText}
            sx={{
              paddingLeft: '6px',
              paddingBottom: '0',
              marginBottom: '-4px',
            }}>
            {/* lazy: Demo Mode shows a generic "for..." instead of the real system name */}
            {isDemoModeEnabled() ? 'for...' : selectedSystem?.name?.replace('Orderly ', '')}
          </Typography>
        </Box>
        {isMobile &&
          <IconButton onClick={(e) => { setOpen(false); e.stopPropagation(); e.preventDefault(); }}
            aria-label={t('close')}
            style={{ position: 'absolute', right: '4px', top: '4px', color: theme.palette.primary[300] }}>
            <CloseIcon />
          </IconButton>
        }
      </Box>
    </>
  );
};